import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { SetStateAction, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import variables from "../../../assets/styles/variables.module.scss";
import { Inform } from "../../Types/Confirm";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface MyComponentProps {
  details: Inform;
}

const InfPopups: React.FC<MyComponentProps> = (props) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const { show, setInfoPopupData, data, functionName, title, info, varient } =
    props.details;
  const handleClose = () => {
    if (setInfoPopupData) {
      setInfoPopupData((preVal) => ({ ...preVal, show: false }));
    }
  };
  const handleCopy = () => {
    if (data) {
      navigator.clipboard.writeText(data);
      setOpenSnackbar(true);
    }
  };
  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            width: "380px", // Customize width
            maxWidth: "100%", // Ensure responsiveness
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              background:
                varient && varient === "delete"
                  ? variables.mainRedLight
                  : variables.enterpriseColorLight,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* pop up varient based icon */}
            {varient === "delete" && (
              <DeleteIcon sx={{ color: variables.mainRed, fontSize: 30 }} />
            )}
            {varient !== "delete" && (
              <TaskAltIcon sx={{ color: "primary", fontSize: 30 }} />
            )}
          </Box>
          <Typography variant="body1">{title}</Typography>
          <DialogContentText
            variant="body2"
            id="alert-dialog-description"
            align="center"
          >
            {info}
          </DialogContentText>
          {data && (
            <Box sx={{ width: "100%", position: "relative" }}>
              <TextField
                value={data}
                disabled
                fullWidth
                multiline
                maxRows={4}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    paddingRight: "40px", // Make space for copy button
                  },
                  "& .MuiInputBase-root": {
                    padding: "8px 14px",
                  },
                }}
                InputProps={{
                  style: {
                    wordBreak: "break-word",
                  },
                  endAdornment: (
                    <Box
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={handleCopy}
                        sx={{
                          color: "action.active",
                          "&:hover": {
                            color: variables.primaryColor,
                          },
                        }}
                      >
                        <ContentCopyIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  ),
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            gap: 2,
            px: 3,
            pb: 3,
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            disableElevation
            onClick={() => functionName()}
            sx={{
              textTransform: "capitalize",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        message="Your Key copied to clipboard"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

export default InfPopups;
